<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<RequirementSearchSection
				:query="q"
				:users="users"
				@search-requirements="searchRequirements($event)"
			/>
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="requirements"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openDialog(item)">
							<td>hoge</td>
							<!-- TODO 一時的なため変更要 -->
							<!-- <td>{{ item.formatted_id }}</td>
							<td>{{ item.matter.quotation_number }}</td>
							<td>{{ item.category.name }}</td>
							<td>{{ item.user.full_name }}</td>
							<td>{{ item.regular_customer_company.name }}</td>
							<td>{{ item.plant_customer_company.name }}</td>
							<td>{{ item.construction_place }}</td>
							<td>{{ item.construction_name }}</td>
							<td>{{ common.formatDate(item.requirement_date) }}</td>
							<td>{{ common.formatDate(item.deadline) }}</td>
							<td>{{ common.formatDate(item.answer.answer_date) }}</td>
							<td>{{ item.inquiry_consideration }}</td>
							<td>{{ item.sales_estimate }}</td>
							<td>{{ item.construction_estimate }}</td>
							<td>{{ item.construction_process_consideration }}</td>
							<td>{{ item.matter.team_member_name }}</td>
							<td>{{ common.formatDate(item.start_date) }}</td>
							<td>{{ item.construction_period }}</td>
							<td>{{ item.matter.situation }}</td>
							<td>{{ item.is_repeater }}</td>
							<td>{{ item.construction_category }}</td>
							<td>{{ item.product_name }}</td>
							<td>{{ item.product_size }}</td>
							<td>{{ item.product_quantity }}</td>
							<td>{{ item.construction_name }}</td>
							<td>{{ item.specification_from_customer }}</td>
							<td>{{ item.drawing_from_customer }}</td>
							<td>{{ item.liquid }}</td>
							<td>{{ item.temperature }}</td>
							<td>{{ item.material_designation }}</td>
							<td>{{ item.thickness_designation }}</td>
							<td>{{ item.hardness_designation }}</td>
							<td>{{ item.personality_standard }}</td>
							<td>{{ item.other }}</td>
							<td>{{ item.test_by_customer_order }}</td>
							<td>{{ item.test_with_witness }}</td>
							<td>{{ item.rubber_removal }}</td>
							<td>{{ item.rubber_disposal }}</td>
							<td>{{ item.environment }}</td>
							<td>{{ item.place_for_shaping }}</td>
							<td>{{ item.place_for_material_storage }}</td>
							<td>{{ item.electricity }}</td>
							<td>{{ item.water }}</td>
							<td>{{ item.steam }}</td>
							<td>{{ item.air }}</td>
							<td>{{ item.foothold_for_work }}</td>
							<td>{{ item.foothold_for_test }}</td>
							<td>{{ item.substrate_blast }}</td>
							<td>{{ item.substrate_tool }}</td>
							<td>{{ item.disposal_by_construction }}</td>
							<td>{{ item.blast_sand_disposal }}</td>
							<td>{{ item.supervisor }}</td> -->
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<RequirementShowDialog
			:dialog.sync="dialog"
			:requirement_data="selectedRequirement"
			@reload-index="fetchRequirements(q, pagination.current)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import RequirementShowDialog from "./components/ConstructionRequirementShowDialog.vue"
import RequirementSearchSection from "./components/ConstructionRequirementSearchSection.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		RequirementShowDialog,
		RequirementSearchSection,
	},
	data() {
		return {
			title: "工事依頼一覧",
			requirements: [],
			authority_flag: false,
			users: [],
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				// TODO
			},
			selectedRequirement: null,
			dialog: false,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchRequirements(this.q, page, true)
	},
	methods: {
		fetchRequirements(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/constructions/requirements", {
					params,
					headers,
				})
				.then((response) => {
					this.requirements = response.data.requirements
					// this.requirements = this.setRequirements(response.data.requirements)
					this.pagination = response.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.users = response.data.users
						this.authority_flag = response.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setRequirements(requirements) {
			// TODO
			return requirements.map((r, i) => {
				r.formatted_id = `KJ-${String(i).padStart(4, "0")}`
				// r.matter.quotation_number
				// r.matter.product_category.name
				// r.user.full_name
				// r.regular_customer_company.name
				// r.plant_customer_company.name
				r.construction_place
				r.construction_name
				r.requirement_date
				// r.deadline
				// r.answer.answer_date
				r.inquiry_consideration
				r.sales_estimate
				r.construction_estimate
				r.construction_process_consideration
				// r.matter.team_member_name
				r.start_date
				r.construction_period
				// r.matter.situation
				r.is_repeater
				r.construction_category
				r.product_name
				r.product_size
				r.product_quantity
				r.construction_name
				r.specification_from_customer
				r.drawing_from_customer
				r.liquid
				r.temperature
				r.material_designation
				r.thickness_designation
				r.hardness_designation
				r.personality_standard
				r.other
				r.test_by_customer_order
				r.test_with_witness
				r.rubber_removal
				r.rubber_disposal
				r.environment
				r.place_for_shaping
				r.place_for_material_storage
				r.electricity
				r.water
				r.steam
				r.air
				r.foothold_for_work
				r.foothold_for_test
				r.substrate_blast
				r.substrate_tool
				r.disposal_by_construction
				r.blast_sand_disposal
				r.supervisor
				return r
			})
		},
		openDialog(item) {
			this.selectedRequirement = item
			this.dialog = true
		},
		getPage(page) {
			this.fetchRequirements(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchRequirements(q) {
			this.q = q
			this.fetchRequirements(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}

function headers() {
	return [
		{
			text: "台帳番号",
			value: "formatted_id",
			width: "100px",
		},
		{
			text: "見積番号",
			value: "matter.quotation_number",
			width: "120px",
		},
		{
			text: "製品区分",
			value: "matter.product_category.name",
			width: "100px",
		},
		{
			text: "依頼者",
			value: "user.full_name",
			width: "100px",
		},
		{
			text: "受注先",
			value: "regular_customer_company.name",
			width: "150px",
		},
		{
			text: "プラントメーカー",
			value: "plant_customer_company.name",
			width: "150px",
		},
		{
			text: "施工場所",
			value: "construction_place",
			width: "150px",
		},
		{
			text: "工事名",
			value: "construction_name",
			width: "200px",
		},
		{
			text: "受付日",
			value: "requirement_date",
			width: "120px",
		},
		{
			text: "提出期限",
			value: "deadline",
			width: "120px",
		},
		{
			text: "提出日",
			value: "answer.answer_date",
			width: "120px",
		},
		{
			text: "引合検討",
			value: "inquiry_consideration",
			width: "100px",
		},
		{
			text: "営業積算",
			value: "sales_estimate",
			width: "100px",
		},
		{
			text: "工事積算",
			value: "construction_estimate",
			width: "100px",
		},
		{
			text: "現地工事工程検討",
			value: "construction_process_consideration",
			width: "100px",
		},
		{
			text: "担当",
			value: "matter.team_member_name",
			width: "100px",
		},
		{
			text: "依頼納期 着工予定",
			value: "start_date",
			width: "120px",
		},
		{
			text: "依頼納期 予定工期",
			value: "construction_period",
			width: "120px",
		},
		{
			text: "受注確度",
			value: "matter.situation",
			width: "80px",
		},
		{
			text: "客先工事区分",
			value: "is_repeater",
			width: "120px",
		},
		{
			text: "工事内容",
			value: "construction_category",
			width: "120px",
		},
		{
			text: "品名",
			value: "product_name",
			width: "200px",
		},
		{
			text: "寸法",
			value: "product_size",
			width: "120px",
		},
		{
			text: "数量",
			value: "product_quantity",
			width: "80px",
		},
		{
			text: "工事名",
			value: "construction_name",
			width: "200px",
		},
		{
			text: "客先仕様書",
			value: "specification_from_customer",
			width: "100px",
		},
		{
			text: "客先図面",
			value: "drawing_from_customer",
			width: "100px",
		},
		{
			text: "内容液（濃度）",
			value: "liquid",
			width: "100px",
		},
		{
			text: "温度",
			value: "temperature",
			width: "100px",
		},
		{
			text: "材質指定",
			value: "material_designation",
			width: "100px",
		},
		{
			text: "厚み指定",
			value: "thickness_designation",
			width: "100px",
		},
		{
			text: "硬さ指定",
			value: "hardness_designation",
			width: "100px",
		},
		{
			text: "物性規格",
			value: "personality_standard",
			width: "100px",
		},
		{
			text: "その他",
			value: "other",
			width: "100px",
		},
		{
			text: "RL検査 客先指定検査",
			value: "test_by_customer_order",
			width: "100px",
		},
		{
			text: "RL検査 立会検査",
			value: "test_with_witness",
			width: "100px",
		},
		{
			text: "既設ゴム剥離 剥離（ゴム種類）",
			value: "rubber_removal",
			width: "100px",
		},
		{
			text: "既設ゴム剥離 産廃",
			value: "rubber_disposal",
			width: "100px",
		},
		{
			text: "施工環境",
			value: "environment",
			width: "100px",
		},
		{
			text: "成形場所",
			value: "place_for_shaping",
			width: "100px",
		},
		{
			text: "材料保管場所",
			value: "place_for_material_storage",
			width: "100px",
		},
		{
			text: "電気（100Ｖ.220Ｖ）",
			value: "electricity",
			width: "100px",
		},
		{
			text: "水",
			value: "water",
			width: "100px",
		},
		{
			text: "蒸気（飽和）",
			value: "steam",
			width: "100px",
		},
		{
			text: "エアー",
			value: "air",
			width: "100px",
		},
		{
			text: "作業用足場・架払い",
			value: "foothold_for_work",
			width: "100px",
		},
		{
			text: "検査用足場・架払い",
			value: "foothold_for_test",
			width: "100px",
		},
		{
			text: "下地処理（ブラスト）",
			value: "substrate_blast",
			width: "100px",
		},
		{
			text: "下地処理（電動工具）",
			value: "substrate_tool",
			width: "100px",
		},
		{
			text: "現地発生産廃（廃プラ）",
			value: "disposal_by_construction",
			width: "100px",
		},
		{
			text: "ブラスト砂産廃",
			value: "blast_sand_disposal",
			width: "100px",
		},
		{
			text: "現地監視人",
			value: "supervisor",
			width: "100px",
		},
	]
}
</script>
